import React from "react";

// Two-column section for slide-in aside forms: a left label/description
// column and a right content column (matches the "Task Information" layout).
export function AsideSection({ icon: Icon, title, description, children, first }) {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-[200px_1fr] gap-x-8 gap-y-4 py-7 ${first ? "" : "border-t border-slate-200/70"}`}>
      <div className="flex items-start gap-2">
        {Icon && <Icon className="w-4 h-4 mt-1 text-slate-500 shrink-0" strokeWidth={1.75} />}
        <div>
          <div className="text-[17px] font-semibold text-slate-900">{title}</div>
          {description && <p className="text-[13px] text-slate-500 mt-1 leading-relaxed">{description}</p>}
        </div>
      </div>
      <div className="space-y-4 min-w-0">{children}</div>
    </div>
  );
}
